/* eslint-disable */
import { CURRENCY_SYMBOLS } from "../../invoice/components/constant";
import { useFormState } from "react-final-form";

const InvoiceDetailsAdmin = (data) => {
  const { values } = useFormState();
  const invoiceData = window.INVOICE;
  const invoice = values?.invoice?.data || {};
  const company = window.COMPANY;

  return (
    <>
      {!invoice || Object.keys(invoice).length === 0 ? (
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="cards">
              <div className="card-bod p-4 text-center">
                <div className="empty-state">
                  <i
                    className="fe fe-file-text mb-3"
                    style={{ fontSize: "48px", color: "#ccc" }}
                  ></i>
                  <h4>No Invoice Selected</h4>
                  <p className="text-muted">
                    Please select a customer and invoice from the dropdown side
                    to view invoice details.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div>
            <div className="">
              {/* Page Header */}
              <div className="">
                <div className="">
                  <div className="mb-2">
                    <div className="">
                      <h5>Invoice Details</h5>
                    </div>
                  </div>

                  <div className="row justify-content-center">
                    <div className="col-lg-12">
                      <div className="cards">
                        <div className="card-bod">
                          <div className="card-table">
                            <div className="card-bod">
                              <div className="invoice-item invoice-item-date">
                                <div className="row">
                                  <div className="col-md-4">
                                    <p className="text-start invoice-details">
                                      Issue Date<span>: </span>
                                      <strong>
                                        {" "}
                                        {invoice?.invoice_formatted_date}
                                      </strong>
                                    </p>
                                  </div>
                                 
                                  <div class="col-md-6">
                                    <p
                                      class="invoice-details"
                                      style={{
                                        textAlign: "start",
                                        marginTop: 5,
                                      }}
                                    >
                                      Invoice No<span>: </span>
                                      <strong>
                                        #{invoice?.invoice_number}
                                      </strong>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              {/* /Invoice Date */}
                              {/* Invoice To */}
                              <div className="invoice-item invoice-item-two">
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="invoice-info">
                                      <strong className="customer-text-one">
                                        Invoiced To<span>:</span>
                                      </strong>
                                      <p className="invoice-details-two">
                                        {invoice?.customer?.company_name}
                                        {invoice?.customer?.user?.full_name}
                                        <br />
                                        {
                                          invoice?.customer?.billing_address
                                            ?.address_line1
                                        }
                                        <br />
                                        {
                                          invoice?.customer?.billing_address
                                            ?.address_line2
                                        }
                                        <br />
                                        {
                                          invoice?.customer?.billing_address
                                            ?.country
                                        }
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* /Invoice To */}
                              {/* Invoice Item */}
                              <div className="invoice-item invoice-table-wrap">
                                <div className="invoice-table-head">
                                  <h6>Items:</h6>
                                </div>
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="table-responsive">
                                      <table className="table table-center table-hover mb-0">
                                        <thead className="thead-light">
                                          <tr>
                                            <th>Product</th>
                                            <th>Quantity</th>
                                            <th>Unit</th>
                                            <th>Rate</th>
                                            <th>Discount</th>
                                            <th>Amount</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {invoice?.invoice_products?.map(
                                            (item, key) => {
                                              return (
                                                <tr key={key}>
                                                  <td  style={{
                                                      maxWidth: 300,
                                                      textWrap : 'auto'
                                                    }}>{item?.label}</td>
                                                  <td>{item?.quantity}</td>
                                                  <td>{item?.unit}</td>
                                                  <td>
                                                    {
                                                      CURRENCY_SYMBOLS[
                                                        company?.currency_type
                                                      ]
                                                    }{" "}
                                                    {item?.rate}
                                                  </td>
                                                  <td>{item.discount} %</td>
                                                  <td>
                                                    {
                                                      CURRENCY_SYMBOLS[
                                                        company?.currency_type
                                                      ]
                                                    }{" "}
                                                    {item?.amount}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* /Invoice Item */}
                              <div className="col-lg-12 col-md-12">
                                <div className="invoice-total-card">
                                  <div className="invoice-total-box">
                                    <div className="invoice-total-inner">
                                      <p>
                                        Taxable{" "}
                                        <span>
                                          {
                                            CURRENCY_SYMBOLS[
                                              company?.currency_type
                                            ]
                                          }
                                          {invoice?.total_invoice_amount}{" "}
                                        </span>
                                      </p>
                                    </div>
                                    <div className="invoice-total-footer">
                                      <h4>
                                        Total Amount{" "}
                                        <span>
                                          {
                                            CURRENCY_SYMBOLS[
                                              company?.currency_type
                                            ]
                                          }
                                          {invoice?.total_invoice_amount}
                                        </span>
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="terms-conditions">
                      <div className="row align-items-center justify-content-between">
                        <div className="col-lg-6 col-md-6">
                          <div className="invoice-terms align-center justify-content-start">
                            <span className="invoice-terms-icon bg-white-smoke me-3">
                              <i className="fe fe-file-text" />
                            </span>
                            <div className="invocie-note">
                              <h6>Terms &amp; Conditions</h6>
                              <p className="mb-0">{invoice?.terms}</p>
                            </div>
                          </div>
                          <div className="invoice-terms align-center justify-content-start">
                            <span className="invoice-terms-icon bg-white-smoke me-3">
                              <i className="fe fe-file-minus" />
                            </span>
                            <div className="invocie-note">
                              <h6>Note</h6>
                              <p className="mb-0">{invoice?.notes}</p>
                            </div>
                          </div>
                        </div>
                        <div className="invoice-sign text-end col-lg-6">
                          <span className="d-block">Authorised Sign</span>
                          <img
                            className="img-fluid d-inline-block"
                            src={invoiceData?.digital_signature_image}
                            alt="sign"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InvoiceDetailsAdmin;
